/*
 * JavaScript detection for CSS – replaces class `no-js` with `js`
 */

(function ( ){

    var defaults = {
        classes: {
            marker: "no-js",
            detected: "js"
        }
    }

    const node = document.querySelector(`html.${defaults.classes.marker}`);

    if (node && node.classList) {
        node.classList.remove(defaults.classes.marker);
        node.classList.add(defaults.classes.detected);
    }

}( ));
